import { api } from 'api/api';
import { EOpportunityFollowUpStatus, IAppointmentCombinedState, IFormValue, IListValue } from 'models';
import { put, select, takeLatest } from 'redux-saga/effects';
import { messagingService } from 'services';
import { handleSagaError } from 'store/common';
import { actionCreator } from './slice';
import { selectors } from './selectors';
import { PayloadAction } from '@reduxjs/toolkit';

export function* saga(): any {
	yield takeLatest(actionCreator.INIT_START, onInitStart);
	yield takeLatest(actionCreator.CLOSE_START, onCloseStart);
}

function* onInitStart(action: ReturnType<typeof actionCreator.INIT_START>): any {
	try {
		const activityId: string = action.payload.activityId;
		const followUps: IAppointmentCombinedState[] = yield api.appointments.getFollowUps(activityId);
		const reasonCodes: IListValue[] = yield api.lov.getByValueType('CloseFollowUpOpportunityReason');
		yield put(
			actionCreator.INIT_COMPLETED({
				followUps,
				reasonCodes
			})
		);
	} catch (error: any) {
		yield handleSagaError(error, [actionCreator.INIT_FAILED()]);
	}
}

function* onCloseStart(): any {
	try {
		const reasonForNoPurchase: IFormValue<string> = yield select(selectors.form.getReasonForNoPurchase);
		const comments: IFormValue<string> = yield select(selectors.form.getComments);
		const opportunityId: string = yield select(selectors.getOpportunityId);
		const onSuccess: () => PayloadAction<any> = yield select(selectors.getOnSuccess);

		// Close the opportunity with the reason and comments
		yield api.followUps.updateFollowUpStatus({
			followUpStatus: EOpportunityFollowUpStatus.CLOSED,
			opportunityId,
			followUpCloseReason: reasonForNoPurchase.newValue,
			followUpCloseComments: comments.newValue
		});

		messagingService.popSnackbar('Opportunity Closed', 'success');
		yield put(actionCreator.INIT_FLUSH());
		yield put(actionCreator.RESET_FORM());
		yield put(actionCreator.CLOSE_COMPLETED());
		if (onSuccess) {
			yield put(onSuccess());
		}
	} catch (error: any) {
		yield handleSagaError(error, [actionCreator.CLOSE_FAILED()]);
	}
}
